import React from 'react'
import Image from '../Includes/Image'
import Texte from '../Includes/Texte'
import styles from './Responsive.module.css'
import Container from '../Includes/Container'
import Apple from '../../Images/Stores/apple.png'
import Google from '../../Images/Stores/google.png'
import Source from '../../Images/Landing/responsive.png'
import {
  useSelector
} from 'react-redux'
import {
  open_link
} from '../../Functions/Functions'
import {
  stores
} from '../../Variables/Variables'

const Responsive = () => {
  const device = useSelector(state => state.device)
  return (
    <Container>
      <div
        className={
          (device.desktop)
            ? styles.mobile
            : styles.desktop
        }
      >
        <Texte
          left={true}
          titre="Toujours #avec vous !#"
          description="Grâce à notre application mobile, restez connecté où que vous soyez..."
        />
        <div className={styles.stores}>
          <Image
            width={80}
            mobile={40}
            alt="Apple"
            src={Apple}
            onClick={() => open_link(stores.apple)}
          />
          <Image
            width={80}
            mobile={40}
            alt="Google"
            src={Google}
            onClick={() => open_link(stores.google)}
          />
        </div>
      </div>
      <Image
        width={75}
        src={Source}
        alt="Responsive"
      />
    </Container>
  )
}

export default Responsive
